import React, { Component } from 'react';
import _ from 'lodash';

import RoutesTable from '../components/RoutesTable';
import RoutesSettingsForm from '../components/RoutesSettingsForm';

import RoutesModel from '../components/RoutesModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, Modal, message } from 'antd';

class RoutesScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    routesSettingsFormModalVisible: false,
  }

  intervalId = null;

  componentWillMount() {
    this.loadData();

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload) {
        this.loadData();;
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    RoutesModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearchName(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        if (typeof (d['routeName']) != 'undefined') {
          return d['routeName'].toLowerCase().includes(searchText.toLowerCase());
        } else {
          return dataAll
        }
        if (searchText == '') {
          return dataAll
        }
      })
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Časy dojezdu - Seznam</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Najít název cesty"
                  value={this.state.searchedTextValue}
                  onSearch={this.onSearchName.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 200 }} />
              </Col>
              <Col span={10} offset={6} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'TIMEOUTSIGNS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ routesSettingsFormModalVisible: true }) }}>Nová cesta</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <RoutesSettingsForm
            type="modal"
            modalVisible={this.state.routesSettingsFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ routesSettingsFormModalVisible: false })
            }}
            onSuccess={(form, values) => {
              RoutesModel.create(values)
                .then(() => {
                  form.resetFields();
                  message.success("Cesta byla vložena!");
                  this.setState({ routesSettingsFormModalVisible: false });
                  this.loadData();
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <RoutesTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRowRemoved={() => {
              this.loadData();
            }}
            onAnyFormSuccess={() => {
              this.loadData();
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default RoutesScreen;



// WEBPACK FOOTER //
// ./src/screens/RoutesScreen.js